























































































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Dots from "@/components/Dots.vue"; // @ is an alias to /src
import { IncomeStatus } from "@/shared/status";

@Component({
  components: {
    Dots,
  },
})
export default class Income extends Vue {
  @Prop() value?: IncomeStatus;
  @Emit("change")
  onChange(): { key: string; value: any } {
    if (this.value != undefined) {
      this.value.updateValidity();
    }
    return { key: "income", value: this.value };
  }
}
